import HorizontalCarousel from "@/components/HorizontalCarousel/index"
import Tag from "@/components/Tag/index"
import { uniqueId } from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"

const FilterApplied = ({ filter, setFilter, dateFormat = 'D/M/YYYY' }) => {
	const search = filter?.search
	const [appliedFilters, setAppliedFilters] = useState([])

	const formatValue = (value) => {
		if (value instanceof Date) {
			return moment(value).format(dateFormat)
		} else if (typeof value !== 'string') {
			return value?.toString ? value?.toString() : value
		} else {
			return value;
		}
	}

	useEffect(() => {
		const otherFilters = Object.keys(filter)?.filter((key) => key !== 'search')?.reduce((prev, curr) => {
			prev[curr] = filter[curr]
			return prev
		}, {});
		if (otherFilters) {
			const filters = []
			Object.keys(otherFilters).forEach((key) => {
				if (Array.isArray(otherFilters[key])) {
					otherFilters[key].map((value) => {
						filters.push({
							id: uniqueId(),
							key: key,
							name: formatValue(value?.name),
							value: formatValue(value?.value),
						})
					})
				} else {
					filters.push({
						id: uniqueId(),
						key: key,
						name: formatValue(otherFilters[key]),
						value: formatValue(otherFilters[key]),
					})
				}
			})
			setAppliedFilters(filters)
		}
	}, [filter])

	const handleRemoveFilter = (id) => () => {
		const appliedFilter = appliedFilters.find((filter) => filter.id === id)

		const newFilterValue = Array.isArray(filter[appliedFilter.key]) ? filter[appliedFilter.key]?.filter((value) => value?.value !== appliedFilter.value) : null;

		const newFilter = {
			...filter,
			[appliedFilter.key]: newFilterValue
		}
		// remove null value
		Object.keys(newFilter).forEach((key) => {
			if (newFilter[key] === null) {
				delete newFilter[key]
			}
		});

		setFilter(newFilter);
	}

	const noFilterApplied = appliedFilters.reduce((prev, curr) => prev + 1, 0);

	return <>
		{(appliedFilters?.length > 0 || search?.length > 0) ?
			<div
				className="data-table3__table__head__row secondary"
			>
				<span>
					Showing results for {[
						search && `"${search}"`,
						noFilterApplied && `${noFilterApplied} applied filter${noFilterApplied > 1 ? 's' : ''}`
					].filter(Boolean).join(' and ')}:
				</span>
				<HorizontalCarousel>
					{appliedFilters.map((filter) => {
						return <Tag
							key={filter.id}
							closable
							onClose={handleRemoveFilter(filter.id)}
							round
							bordered
							addClass="filter--tag"
							data-testid='filterApplied__tag'
						>
							<span className="data_table__filterapplied__tag">
								{filter.name ?? filter.value}
							</span>
						</Tag>
					})}
				</HorizontalCarousel>
			</div > :
			<></>
		}
	</>
}

FilterApplied.propTypes = {
	filter: PropTypes.objectOf(
		PropTypes.shape({
			search: PropTypes.string,
		})
	).isRequired,
	setFilter: PropTypes.func.isRequired,
	dateFormat: PropTypes.string,
}

export default FilterApplied;
